import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  root: {
    display: 'flex',
    borderTop: `1px solid ${theme.palette.neutralLight}`,
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.neutralWhite,
    padding: '1rem',
    selectors: {
      [layout.breakpoints.min.md]: {
        padding: '1rem 1.5rem',
      },
    },
  },
});
